import { memo, useMemo } from "react";
import { Loader2, Inbox as InboxIcon } from "lucide-react";
import { EmailListItem } from "./EmailListItem";
import { threadKey, PAGE, buildHLRegex } from "./inboxUtils";

const EmailListInner = ({
  items, total, selectedId, isInbox, selectMode, checked, leavingIds, activeFolder,
  threadCounts, hasMore, loadingMore, listScrollRef, onListScroll, catStyle, catLabel, highlight,
  onSelect, onToggleChecked, onOpenThread, onReply, onReplyAll, onForward, onDelete, onToggleReadItem,
}) => {
  const hlRe = useMemo(() => buildHLRegex(highlight), [highlight]);
  return (
  <div ref={listScrollRef} onScroll={onListScroll} className="flex-1 overflow-y-auto scroll-thin bg-gray-50/60 px-2 pt-2">
    {items.length === 0 && (
      <div className="p-10 text-center text-gray-400 text-sm flex flex-col items-center gap-3">
        <InboxIcon className="h-8 w-8 opacity-40" />Nessuna email in questa cartella.
      </div>
    )}
    {items.map((it, i) => (
      <EmailListItem
        key={it.id} it={it} i={i}
        isSelected={selectedId === it.id}
        isChecked={checked.includes(it.id)}
        isInbox={isInbox}
        selectMode={selectMode}
        activeFolder={activeFolder}
        threadCount={it.thread_count || threadCounts[threadKey(it.subject)] || 1}
        threadPosition={it.thread_position}
        threadReceivedTotal={it.thread_received_total}
        leaving={leavingIds.includes(it.id)}
        catStyle={catStyle} catLabel={catLabel} hlRe={hlRe}
        onSelect={onSelect} onToggleChecked={onToggleChecked} onOpenThread={onOpenThread}
        onReply={onReply} onReplyAll={onReplyAll} onForward={onForward} onDelete={onDelete} onToggleReadItem={onToggleReadItem}
      />
    ))}
    {loadingMore && (
      <div data-testid="loading-more" className="py-4 flex items-center justify-center text-gray-400 text-xs gap-2">
        <Loader2 className="h-4 w-4 animate-spin" />Carico altre email…
      </div>
    )}
    {!hasMore && items.length >= PAGE && (
      <div className="py-4 text-center text-[11px] text-gray-300">Fine dei messaggi</div>
    )}
  </div>
  );
};

export const EmailList = memo(EmailListInner);
